export default "__VITE_ASSET__CYfIoRcR__"